/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CounterpartyOperator {
    IS = 'IS',
    IS_ANY_OF = 'IS_ANY_OF',
    IS_VALIDATED = 'IS_VALIDATED',
    IS_NOT_VALIDATED = 'IS_NOT_VALIDATED',
}
